import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, IconButton } from '@material-ui/core';
import Icon from 'sharedComponents/Icon';
import useScreen from 'hooks/useScreen';
import { useTranslation } from 'react-i18next';
import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';
import { purchaseSurvey, refinanceSurvey } from 'lib/surveys';
import SurveySummary from './components/SurveySummary';

import useStyles from './useStyles';

const BuyerRequestPage = props => {
  const { surveyValues, onRetake, onSubmit, submitButtonLabel, disabled } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const { isDesktop } = useScreen();

  const isRefinanceFlow = MortgageSurveyPresenter.isRefinanceFlow(surveyValues);
  const { questions } = isRefinanceFlow ? refinanceSurvey : purchaseSurvey;

  return (
    <Box className={classes.container}>
      <Box className={classes.paper}>
        <Box className={classes.header}>
          <Typography variant="h2" className={classes.headerText}>
            {t('components.BuyerRequestPage.header')}
          </Typography>
          {isDesktop ? (
            <Button onClick={onRetake} variant="outlined">
              {t('components.BuyerRequestPage.retakeButton')}
            </Button>
          ) : (
            <IconButton onClick={onRetake} className={classes.mobileButton}>
              <Icon name="retake" />
            </IconButton>
          )}
        </Box>
        <Box className={classes.content}>
          <SurveySummary surveyValues={surveyValues} questions={questions} />
        </Box>
        <Box className={classes.controlBar}>
          <Button onClick={onSubmit} className={classes.submitButton} disabled={disabled}>
            {submitButtonLabel}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

BuyerRequestPage.propTypes = {
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  onRetake: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitButtonLabel: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default BuyerRequestPage;



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRequestPage/BuyerRequestPage.js